import OurExpert from '@images/checkout/our-expert.svg'
import styles from '@pages/Checkout/routes/Confirmation/Confirmation.module.scss'
import { Button, Heading, Image, Panel, Paragraph } from '@ui-kit'
import { Trans, useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

export const ExpertPanel = () => {
  const { t } = useTranslation()

  const handleGetInTouch = () => {
    window.open('', '_blank')
  }

  return (
    <Panel
      surface={0}
      border='neutral-2'
      padding={0}
      className={styles['confirmation__expert-panel']}
    >
      <Row className={styles['confirmation__expert-panel__content']}>
        <Image src={OurExpert} width='132px' height='205px' />

        <Column
          className={styles['confirmation__expert-panel__description']}
          justifyContent='space-between'
        >
          <Heading level={3} weight={600}>
            {t('checkout.confirmation.expert.panel.heading')}
          </Heading>

          <Paragraph>
            <Trans i18nKey='checkout.confirmation.expert.panel.description' />
          </Paragraph>

          <Row justifyContent='flex-end'>
            <Button
              variant='outlined'
              onClick={handleGetInTouch}
              data-testid='expert-panel-button'
            >
              <Trans i18nKey='checkout.confirmation.expert.panel.button.get.in.touch' />
            </Button>
          </Row>
        </Column>
      </Row>
    </Panel>
  )
}
